module.exports = __webpack_public_path__ + "04_very_short_brown.a0cfdd61.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_very_short_brown.png
// module id = 8UwZ
// module chunks = 0